<template>
  <b-card class="no-border animated fadeIn">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2"><b-badge :variant="statusColor">{{status}}</b-badge> Order-{{number}}</h5>
      <div class="pull-right">
        <b-button v-b-modal.delete_order variant="outline-danger">Remove</b-button>
        <b-button variant="outline-primary" @click="goToSection('Edit Order')"><i class="fa fa-pencil-square-o"></i>&nbsp; Edit</b-button>
      </div>
    </div>
    <div class="list-group mb-2">
      <b-nav>
        <b-nav-item @click="goToSection('Order Detail')"    :active="section === ''"        >Detail</b-nav-item>
        <b-nav-item @click="goToSection('Order Units')"     :active="section === 'units'"    >Units</b-nav-item>
      </b-nav>
    </div>
    <b-modal
      id="delete_order"
      title="Delete Order"
      header-bg-variant="danger"
      ok-variant="danger"
      @ok="deleteOrder()">
      <p class="my-4">Are you sure want to delete this order ?</p>
    </b-modal>
    <router-view></router-view>
  </b-card>
</template>
<script>
export default {
  name: 'order_detail',
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[4] || '',
      loaded: false,
      colors: {
        UNCONFIRMED: 'info',
        CANCELLED: 'danger',
        CONFIRMED: 'success',
        CONFIRMED_0: 'success',
      },
    };
  },
  created() {
    const { orderId, shipmentId } = this.$route.params;
    const breadcrumb = [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
    ];

    if (shipmentId) {
      breadcrumb.push({ to: 'shipments', name: 'Shipments' });
      breadcrumb.push({ to: `${shipmentId}/orders`, name: 'Detail' });
      breadcrumb.push({ to: orderId, name: 'Order Detail' });
    } else {
      breadcrumb.push({ to: 'orders', name: 'Orders' });
      breadcrumb.push({ to: orderId, name: 'Detail' });
    }

    this.$store.commit('shipment_md/orders/SET_DETAIL_ID', orderId);
    this.$store.commit('SET_BREADCRUMB_ITEMS', breadcrumb);
    this.$store.dispatch('shipment_md/orders/LOAD_DETAIL_DATA');
  },
  computed: {
    orderId() {
      return this.$route.params.orderId;
    },
    detailedInfo() {
      return this.$store.getters['shipment_md/orders/get_detail_data'];
    },
    number() {
      return this.detailedInfo.number;
    },
    status() {
      return this.detailedInfo.status;
    },
    statusColor() {
      return this.colors[this.status];
    },
  },
  methods: {
    deleteOrder() {
      this.$store.dispatch('shipment_md/orders/DELETE_DATA').then((ok) => {
        if (ok) this.$router.push('/shipment_md/orders');
      });
    },
    goToSection(section) {
      const { orderId, shipmentId } = this.$route.params;

      if (section === 'Order Detail') {
        this.section = '';
      } else if (section === 'Order Units') {
        this.section = 'units';
      } else if (section === 'Edit Order') {
        this.section = 'edit';
      }

      this.$store.commit('shipment_md/orders/CLEAR_SELECTED_VALUE');
      this.$router.push({
        name: section,
        params: {
          orderId,
          shipmentId,
        },
      });
    },
  },
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/orders/Detail.vue